var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tag } from "@cloudy/ui";
import { formatCurrency, handleSupabaseError } from "@cloudy/utils/common";
import { WorkspaceRole } from "@cloudy/utils/common";
import { useMutation, useQuery } from "@tanstack/react-query";
import { CircleFadingArrowUpIcon, CreditCardIcon, UserPlus2Icon, UserRoundMinusIcon, XIcon } from "lucide-react";
import posthog from "posthog-js";
import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { apiClient } from "src/api/client";
import { queryClient } from "src/api/queryClient";
import { supabase } from "src/clients/supabase";
import { Button } from "src/components/Button";
import { Input } from "src/components/Input";
import LoadingSpinner from "src/components/LoadingSpinner";
import { MainLayout } from "src/components/MainLayout";
import { SelectDropdown } from "src/components/SelectDropdown";
import { useUser } from "src/stores/user";
import { useWorkspace, useWorkspaceRole, useWorkspaceSlug } from "src/stores/workspace";
import { pluralize } from "src/utils/strings";
import { useCustomerStatus } from "src/utils/useCustomerStatus";
import { useSubscriptionModalStore } from "../pricing/subscriptionModalStore";
var useUpdateWorkspace = function () {
    var workspace = useWorkspace();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var newOrg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, supabase.from("workspaces").update(data).eq("id", workspace.id).select().single()];
                    case 1:
                        newOrg = _a.sent();
                        return [2 /*return*/, newOrg];
                }
            });
        }); },
    });
};
var useBillingPortal = function () {
    var wsSlug = useWorkspaceSlug();
    return useQuery({
        queryKey: [wsSlug, "billingPortal"],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.get("/api/payments/billing", {
                            params: {
                                wsSlug: wsSlug,
                                returnUrl: window.location.href,
                            },
                        })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        }); },
    });
};
var useWorkspaceMembers = function () {
    var workspace = useWorkspace();
    return useQuery({
        queryKey: [workspace.slug, "members"],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var users, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = handleSupabaseError;
                        return [4 /*yield*/, supabase
                                .from("workspace_users")
                                .select("user:users(id, name, email), role")
                                .eq("workspace_id", workspace.id)
                                .order("created_at", { ascending: true })];
                    case 1:
                        users = _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/, users.filter(function (user) { return user.user !== null; })];
                }
            });
        }); },
    });
};
var usePendingInvites = function () {
    var workspace = useWorkspace();
    return useQuery({
        queryKey: [workspace.slug, "pendingInvites"],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var invites, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = handleSupabaseError;
                        return [4 /*yield*/, supabase.from("user_pending_invites").select("*, user:users(email)").eq("workspace_id", workspace.id)];
                    case 1:
                        invites = _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/, invites];
                }
            });
        }); },
    });
};
var useRemoveMember = function () {
    var workspace = useWorkspace();
    return useMutation({
        mutationFn: function (userId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, supabase.from("workspace_users").delete().eq("workspace_id", workspace.id).eq("user_id", userId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: [workspace.slug, "members"] });
        },
    });
};
var useAddMember = function () {
    var workspace = useWorkspace();
    return useMutation({
        mutationFn: function (email) { return __awaiter(void 0, void 0, void 0, function () {
            var user, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = handleSupabaseError;
                        return [4 /*yield*/, supabase.from("users").select("id,is_pending").eq("email", email).maybeSingle()];
                    case 1:
                        user = _a.apply(void 0, [_b.sent()]);
                        if (!(user && !user.is_pending)) return [3 /*break*/, 3];
                        return [4 /*yield*/, supabase.from("workspace_users").insert({
                                workspace_id: workspace.id,
                                user_id: user.id,
                                role: WorkspaceRole.MEMBER,
                            })];
                    case 2:
                        _b.sent();
                        posthog.capture("workspace_member_added", {
                            workspace_id: workspace.id,
                            user_id: user.id,
                        });
                        return [2 /*return*/, { added: true }];
                    case 3: return [4 /*yield*/, apiClient.post("/api/workspaces/members/invite", {
                            email: email,
                            workspaceId: workspace.id,
                        })];
                    case 4:
                        _b.sent();
                        posthog.capture("workspace_member_invited", {
                            workspace_id: workspace.id,
                            email: email,
                        });
                        return [2 /*return*/, { added: false, invited: true }];
                }
            });
        }); },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: [workspace.slug, "members"] });
            queryClient.invalidateQueries({ queryKey: [workspace.slug, "pendingInvites"] });
        },
    });
};
var useUpdateMemberRole = function () {
    var workspace = useWorkspace();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var userId = _b.userId, role = _b.role;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, supabase.from("workspace_users").update({ role: role }).eq("workspace_id", workspace.id).eq("user_id", userId)];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: [workspace.slug, "members"] });
        },
    });
};
var useDeletePendingInvite = function () {
    var workspace = useWorkspace();
    return useMutation({
        mutationFn: function (inviteId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, supabase.from("user_pending_invites").delete().eq("id", inviteId).eq("workspace_id", workspace.id)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: [workspace.slug, "pendingInvites"] });
        },
    });
};
export var WorkspaceSettingsView = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var workspace = useWorkspace();
    var currentUser = useUser();
    var role = useWorkspaceRole();
    var customerStatus = useCustomerStatus().data;
    var billingPortalUrl = useBillingPortal().data;
    var members = useWorkspaceMembers().data;
    var pendingInvites = usePendingInvites().data;
    var deletePendingInvite = useDeletePendingInvite().mutate;
    var removeMember = useRemoveMember().mutate;
    var _k = useAddMember(), addMember = _k.mutate, isAddingMember = _k.isPending;
    var updateMemberRole = useUpdateMemberRole().mutate;
    var _l = useState(""), newMemberEmail = _l[0], setNewMemberEmail = _l[1];
    var _m = useForm({
        defaultValues: {
            name: workspace.name,
            slug: workspace.slug,
        },
    }), register = _m.register, handleSubmit = _m.handleSubmit, watch = _m.watch, reset = _m.reset, errors = _m.formState.errors;
    var setShowSubscriptionModal = useSubscriptionModalStore().setIsOpen;
    var handleOpenSubscriptionModal = function () {
        setShowSubscriptionModal(true, true);
    };
    var _o = useUpdateWorkspace(), updateWorkspace = _o.mutateAsync, isPending = _o.isPending;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateWorkspace(data)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        reset({
            name: workspace.name,
            slug: workspace.slug,
        });
    }, [workspace]);
    var watchSlug = watch("slug");
    var watchName = watch("name");
    var handleAddMember = function () {
        if (newMemberEmail) {
            addMember(newMemberEmail, {
                onSuccess: function (result) {
                    if (result.added) {
                        // Show success message
                        alert("Member added successfully");
                    }
                    else if (result.invited) {
                        // Show invitation sent message
                        alert("Invitation email sent");
                    }
                    setNewMemberEmail("");
                },
            });
        }
    };
    var roleOptions = [
        { value: WorkspaceRole.OWNER, label: "Owner" },
        { value: WorkspaceRole.MEMBER, label: "Member" },
    ];
    var handleRoleChange = function (userId, newRole) {
        updateMemberRole({ userId: userId, role: newRole });
    };
    var isOwner = role === WorkspaceRole.OWNER;
    return (_jsx(MainLayout, { className: "flex h-screen flex-col overflow-y-scroll", children: _jsxs("div", { className: "flex h-[2000px] w-full flex-col gap-4 p-6 pt-12", children: [_jsx("h1", { className: "font-display text-2xl font-bold", children: "Workspace settings" }), _jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "flex flex-col gap-4", children: [_jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("label", { htmlFor: "name", children: "Workspace name" }), _jsx(Input, __assign({}, register("name", { required: "Workspace name is required" }), { placeholder: "Brain Fog Inc.", error: !!errors.name, disabled: !isOwner })), errors.name && _jsx("p", { className: "mt-1 text-sm text-red-500", children: errors.name.message })] }), _jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("label", { htmlFor: "slug", children: "Workspace slug" }), _jsxs("div", { className: "flex items-center", children: [_jsx("span", { className: "mr-2 text-sm text-secondary", children: "app.usecloudy.com/workspaces/" }), _jsx(Input, __assign({}, register("slug", {
                                            required: "Slug is required",
                                            pattern: {
                                                value: /^[a-z0-9-]+$/,
                                                message: "Slug can only contain lowercase letters, numbers, and hyphens",
                                            },
                                        }), { placeholder: "brain-fog-inc", className: "flex-grow", error: !!errors.slug, disabled: !isOwner }))] }), errors.slug && _jsx("p", { className: "mt-1 text-sm text-red-500", children: errors.slug.message })] }), isOwner && (_jsx(Button, { className: "self-end", type: "submit", disabled: isPending || !watchSlug || !watchName, children: isPending ? _jsx(LoadingSpinner, { size: "xs", variant: "background" }) : "Save Changes" }))] }), _jsxs("div", { className: "flex flex-col gap-2", children: [_jsx("h2", { className: "font-display text-lg font-bold", children: "Members" }), _jsxs("div", { className: "flex flex-col gap-4", children: [members === null || members === void 0 ? void 0 : members.map(function (member) {
                                    var isCurrentUser = member.user.id === currentUser.id;
                                    return (_jsxs("div", { className: "flex flex-row items-center justify-between gap-2", children: [_jsxs("div", { className: "flex flex-col", children: [_jsx("span", { className: "text-sm", children: member.user.name || "-" }), _jsx("span", { className: "text-sm text-secondary", children: member.user.email })] }), _jsxs("div", { className: "flex flex-row items-center gap-2", children: [_jsx(SelectDropdown, { options: roleOptions, value: member.role, onChange: function (newRole) { return handleRoleChange(member.user.id, newRole); }, size: "sm", disabled: !isOwner }), !isCurrentUser && (_jsx(Button, { variant: "outline", size: "icon-sm", onClick: function () { return removeMember(member.user.id); }, disabled: !isOwner, children: _jsx(UserRoundMinusIcon, { className: "size-4" }) }))] })] }, member.user.id));
                                }), pendingInvites === null || pendingInvites === void 0 ? void 0 : pendingInvites.map(function (invite) { return (_jsxs("div", { className: "flex flex-row items-center justify-between gap-2", children: [_jsx("div", { className: "flex flex-col gap-1 text-sm text-secondary", children: _jsx("span", { children: invite.user.email }) }), _jsxs("div", { className: "flex flex-row items-center gap-2", children: [_jsx("span", { className: "text-xs font-medium text-secondary", children: "Pending" }), isOwner && (_jsx(Button, { variant: "outline", size: "icon-sm", onClick: function () { return deletePendingInvite(invite.id); }, children: _jsx(XIcon, { className: "size-4" }) }))] })] }, invite.id)); })] }), isOwner && (_jsxs("div", { className: "flex flex-col gap-2", children: [_jsx("span", { className: "text-sm font-medium", children: "Add a Member" }), _jsxs("div", { className: "flex flex-row items-center gap-2", children: [_jsx(Input, { placeholder: "anyone@email.com", value: newMemberEmail, onChange: function (e) { return setNewMemberEmail(e.target.value); }, className: "flex-grow" }), _jsxs(Button, { variant: "outline", onClick: handleAddMember, disabled: isAddingMember || !newMemberEmail, children: [_jsx(UserPlus2Icon, { className: "size-4" }), _jsx("span", { children: isAddingMember ? _jsx(LoadingSpinner, { size: "xs", variant: "primary" }) : "Add" })] })] })] }))] }), _jsxs("div", { className: "flex flex-col gap-2", children: [_jsxs("div", { className: "flex flex-row items-center gap-1", children: [_jsx("h2", { className: "font-display text-lg font-bold", children: "Subscription Plan" }), _jsx(Tag, { children: ((_a = customerStatus === null || customerStatus === void 0 ? void 0 : customerStatus.customerStatus) === null || _a === void 0 ? void 0 : _a.isActive) ? (customerStatus.customerStatus.isTrialing ? (_jsx("span", { className: "text-secondary", children: "Trial" })) : (_jsx("span", { className: "text-green-600", children: "Active" }))) : (_jsx("span", { className: "text-red-600", children: "Inactive" })) })] }), _jsxs("div", { children: [pluralize((_c = (_b = customerStatus === null || customerStatus === void 0 ? void 0 : customerStatus.customerStatus) === null || _b === void 0 ? void 0 : _b.unitCount) !== null && _c !== void 0 ? _c : 0, "user"), " @", " ", formatCurrency((_e = (_d = customerStatus === null || customerStatus === void 0 ? void 0 : customerStatus.customerStatus) === null || _d === void 0 ? void 0 : _d.unitPrice) !== null && _e !== void 0 ? _e : 0), "/seat =", " ", formatCurrency((_g = (_f = customerStatus === null || customerStatus === void 0 ? void 0 : customerStatus.customerStatus) === null || _f === void 0 ? void 0 : _f.totalPrice) !== null && _g !== void 0 ? _g : 0), " monthly charges"] }), isOwner ? (((_h = customerStatus === null || customerStatus === void 0 ? void 0 : customerStatus.customerStatus) === null || _h === void 0 ? void 0 : _h.isActive) && !customerStatus.customerStatus.isTrialing ? (_jsx(Link, { to: (_j = billingPortalUrl === null || billingPortalUrl === void 0 ? void 0 : billingPortalUrl.url) !== null && _j !== void 0 ? _j : "", children: _jsxs(Button, { variant: "outline", children: [_jsx(CreditCardIcon, { className: "size-4" }), _jsx("span", { children: "Manage Subscription" })] }) })) : (_jsxs(Button, { variant: "outline", onClick: handleOpenSubscriptionModal, className: "self-start text-accent", children: [_jsx(CircleFadingArrowUpIcon, { className: "size-4" }), _jsx("span", { children: "Subscribe" })] }))) : null] })] }) }));
};
